// extracted by mini-css-extract-plugin
export default {"root":"PlasmicEditIconRed_root__lHWby","img":"PlasmicEditIconRed_img__anlUU","imgrotated":"PlasmicEditIconRed_imgrotated__x97PW"};